import React from "react";
import { showInfoToast, showSuccessToast  } from "../../validation/ToastContainer";
import { ScanStatus } from "../../vars";
import { Spinner } from "../../view/Spinner";
import * as vulscanService from "./vulscanService";
import {
    finishLocalProcessingTask,
    startLocalProcessingTask
} from "../../processing-tasks/processingTasksRegistry";


function ScanButton({ type, target, command, scanStatus, setScanStatus }) {
    
    const buttonDisabled = target === "" || command === "";

    const startScan = async (e) => {
        if (buttonDisabled === true) return;
        e.preventDefault()

        if (target !== "" && command !== "") {
            if (!buttonDisabled) {
                setScanStatus(ScanStatus.PROCESSING);
                const processingTaskId = startLocalProcessingTask({
                    id: `vulnerability-scan-${Date.now()}`,
                    type: "Vulnerability Scan",
                    title: "Vulnerability Scan",
                    target,
                    details: command
                });
                showInfoToast('Vulnerability Scan started', 'Vulnerability Scan');
                return await vulscanService.startVulnerabilityScan(type.id, type.type, command, target)
                    .then(() => setScanStatus(ScanStatus.DONE))    
                    .then(() => showSuccessToast('Vulnerability Scan completed', 'Vulnerability Scan'))
                    .then(() => vulscanService.listPageable(0,10))
                    .finally(() => finishLocalProcessingTask(processingTaskId));
            }
        }  
    }

    const showSpinner = scanStatus === ScanStatus.PROCESSING;

    return (     
        <div className={`network-scan-primary-action-v2 ${buttonDisabled && 'is-disabled'}`}
            onClick={buttonDisabled ? null : startScan}>
            <span className={`${showSpinner && 'spinner-visible'}`}>Scan</span>
            {showSpinner && <Spinner />}
        </div>
    )

}

export default ScanButton;

